import {
  CButton,
  CButtonGroup,
  CCol,
  CFormGroup,
  CInput,
  CLabel,
  CRow,
} from "@coreui/react";
import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { createItem, updateItem, ItemRequestStatus } from "../../api/generics";
import Errors, { getFieldErrors } from "../../models/errors";
import { SUCCESS } from "../../utils/constants/tags";
import { FieldErrors } from "../form/FieldErrors";
import { errorAlert } from "../utils/messages";
import { emptyValueOnUndefined } from "../../utils/fields";
import { RootState } from "../../store";
import { useSelector } from "react-redux";
import AssetType, { newAssetType } from "../../models/asset-type";

interface AssetTypeFormProps {
  initialAssetType?: AssetType;
  initialErrors?: Errors;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const AssetTypeForm: React.FC<AssetTypeFormProps> = ({
  initialAssetType,
  initialErrors,
  onCancel,
  onSuccess,
}) => {
  const company = useSelector((state: RootState) => state.company.data.company);
  const [editingAssetType, setEditingAssetType] = useState<AssetType>(
    initialAssetType ? initialAssetType : newAssetType()
  );

  const [errors, setErrors] = useState<Errors>(
    initialErrors ? initialErrors : {}
  );
  const [submitting, setSubmitting] = useState(false);

  const onNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEditingAssetType({
      ...editingAssetType,
      name: e.target.value,
    });
  };

  const onSave = async () => {
    setSubmitting(true);
    let toSendAssetType = {
      ...editingAssetType,
      companyId: company.id,
    };
    let requestPromise: Promise<ItemRequestStatus<AssetType>>;
    if (editingAssetType.id === undefined) {
      requestPromise = createItem<AssetType>(
        "/asset_types/create/",
        toSendAssetType
      );
    } else {
      requestPromise = updateItem<AssetType>(
        `/asset_types/${toSendAssetType.id}/`,
        toSendAssetType
      );
    }

    const assetTypeStatus = await requestPromise;

    if (assetTypeStatus.status !== SUCCESS) {
      if (assetTypeStatus.errors !== undefined) {
        setErrors(assetTypeStatus.errors);
      }

      let message = "Ha ocurrido un error!!";
      if (assetTypeStatus.detail !== undefined) {
        message = assetTypeStatus.detail;
      }
      errorAlert(message);
    } else {
      setErrors({});
      clearForm();
      onSuccess();
    }
    setSubmitting(false);
  };

  const onClose = () => {
    clearForm();
    onCancel();
  };

  const clearForm = () => {
    setEditingAssetType(newAssetType());
  };

  useEffect(() => {
    setEditingAssetType(initialAssetType ? initialAssetType : newAssetType());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialAssetType]);

  useEffect(() => {
    setErrors(initialErrors ? initialErrors : {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialErrors]);

  return (
    <>
      <fieldset disabled={submitting}>
        <CFormGroup>
          <CRow>
            <CCol md={2}>
              <CLabel>Nombre:</CLabel>
            </CCol>
            <CCol>
              <CInput
                type="text"
                value={emptyValueOnUndefined(editingAssetType.name)}
                onChange={onNameChange}
                placeholder="Nombre"
              ></CInput>
              <FieldErrors
                errors={getFieldErrors("name", errors) as string[]}
              ></FieldErrors>
            </CCol>
          </CRow>
        </CFormGroup>
        <CFormGroup className="float-right">
          <CButtonGroup>
            <CButton type="button" color="secondary" onClick={onClose}>
              Atras
            </CButton>
            <CButton type="submit" color="primary" onClick={onSave}>
              {submitting ? (
                <Spinner
                  animation="grow"
                  style={{
                    height: "17px",
                    width: "17px",
                    marginTop: "auto",
                    marginBottom: "auto",
                    marginRight: "10px",
                  }}
                />
              ) : (
                <></>
              )}
              {submitting ? "Guardando..." : "Guardar"}
            </CButton>
          </CButtonGroup>
        </CFormGroup>
      </fieldset>
    </>
  );
};

export default AssetTypeForm;
